// src/modules/accounting/pages/AccountingSection.jsx
// Renders a single accounting section with a header + back button.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Button, Result, Card, Space, Grid } from 'antd';
import { ArrowLeftOutlined, LockOutlined } from '@ant-design/icons';
import { usePermissions } from '../../../hooks/usePermissions';

const { Title } = Typography;
const { useBreakpoint } = Grid;

export default function AccountingSection({ section }) {
  const navigate = useNavigate();
  const { canViewField } = usePermissions();
  const screens = useBreakpoint();

  const goBack = () => navigate('/accounting');

  const hasAccess = canViewField('accounting', section.fieldName);

  return (
    <div style={{ padding: screens.xs ? 16 : 24 }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          marginBottom: 20,
          flexWrap: 'wrap',
        }}
      >
        <Button icon={<ArrowLeftOutlined />} onClick={goBack}>
          Back
        </Button>
        <Space size={10} align="center">
          <span style={{ fontSize: 20, color: section.color, display: 'flex' }}>
            {section.icon}
          </span>
          <Title level={4} style={{ margin: 0 }}>
            {section.title}
          </Title>
        </Space>
      </div>

      {hasAccess ? (
        <section.Component />
      ) : (
        <Card>
          <Result
            status="403"
            title="Access Denied"
            subTitle={`You don't have permission to view ${section.title}.`}
            icon={<LockOutlined style={{ fontSize: 48, color: '#ff4d4f' }} />}
            extra={
              <Button type="primary" onClick={goBack}>
                Back to Accounting
              </Button>
            }
          />
        </Card>
      )}
    </div>
  );
}
